import VusPanel from './vus-panel.vue';
export default VusPanel;



// WEBPACK FOOTER //
// ./src/components/vus-panle/index.js